<template>
  <div>
    <el-form
      ref="numberValidateForm"
      :model="addItem"
      size="mini"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="用户名">
        <div style="display: flex">
          <el-input v-model="addItem.username" style="width: 50%" />
          <el-button
            size="mini "
            type="primary" class="edit-button"
            :loading="addButtonLoading"
            style="margin-left: 10px"
            @click="checkuser"
            >检测</el-button
          >
        </div>
        <div
          v-if="addItem.memberId"
          style="display: flex; width: 100px; margin-top: 10px"
          class="userinfo"
          :class="addItem.sex == 1 ? 'woman' : 'man'"
        >
          <div class="avator">
            <el-avatar :src="addItem.avator" />
          </div>
          <label for="">{{ addItem.nickname }}</label>
        </div>
      </el-form-item>
      <el-form-item label="上传">
        <el-radio-group v-model="addItem.type">
          <el-radio :label="1">图片</el-radio>
          <el-radio :label="2">视频</el-radio>
        </el-radio-group>
        <UploadPic
          ref="upload"
          :is-video="addItem.type && addItem.type == 2"
          @upLoadImage="upLoadImage"
        />
      </el-form-item>
      <el-form-item label="阅后即焚">
        <el-switch v-model="addItem.isBurn" />
      </el-form-item>
      <el-form-item label="设置礼物">
        <el-switch v-model="addItem.isNeedGift" />
      </el-form-item>
      <el-form-item v-if="addItem.isNeedGift" label="选择礼物">
        <el-select v-model="addItem.giftId" placeholder="请选择" size="mini">
          <el-option
            v-for="item in giftList"
            :key="item.id"
            :label="`${item.name}(￥${item.price})`"
            :value="item.id"
            :style="{ color: item.type == 0 ? '#1890ff' : 'red' }"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="人工审核">
        <el-select
          v-model="addItem.isPassAudit"
          placeholder="请选择"
          size="mini"
        >
          <el-option
            v-for="item in isPassAuditoptions"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="通过鉴黄">
        <el-switch v-model="addItem.isPassPorn" />
      </el-form-item>
      <el-form-item label="是否本人">
        <el-switch v-model="addItem.isSelf" />
      </el-form-item>
      <el-form-item label="评分">
        <el-slider v-model="addItem.aiPoint" style="width: 200px" />
      </el-form-item>
      <el-popconfirm
        confirm-button-text="确定"
        cancel-button-text="取消"
        icon="el-icon-info"
        icon-color="red"
        title="确定添加？"
        @onConfirm="AddPhoto"
      >
        <el-button slot="reference" size="mini" type="primary" class="edit-button">提交</el-button>
      </el-popconfirm>
    </el-form>
  </div>
</template>
<script>
import UploadPic from "@/components/Upload/UploadPic"; // 上传
export default {
  components: { UploadPic },
  data() {
    return {
      addItem: {
        type: 1,
        isPassPorn: true,
        isPassAudit: 1,
      },
      addButtonLoading: false,
      // 人工抽查
      isPassAuditoptions: [
        {
          value: 0,
          name: "未做",
        },
        {
          value: 1,
          name: "通过",
        },
        {
          value: 2,
          name: "不通过",
        },
      ],
      giftList: [],
    };
  },
  mounted() {
    setTimeout(() => {
      this.getgiftList();
    }, 0);
  },
  methods: {
    upLoadImage(e) {
      this.addItem.path = e;
    },
    // 获取礼物列表
    getgiftList() {
      this.$api.global
        .getAllGiftInfos()
        .then((res) => {
          //   console.log(res)
          this.giftList = res;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 检测用户
    checkuser() {
      if (!this.addItem.username) {
        return this.$message.error("请填写用户手机号码");
      }
      this.addButtonLoading = true;
      // var params = {
      //   ids: this.addItem.username
      // }
      // console.log(params)
      this.$api.global
        .getUserInfoByUserName(this.addItem.username)
        .then((res) => {
          console.log(res);
          // this.userInfo = res
          // this.dynamicDetails.username=res.username
          this.addItem.memberId = res.id;
          this.addItem.nickname = res.nickname;
          this.addItem.avator = res.avator;
          this.addItem.sex = res.sex;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.addButtonLoading = false;
        });
    },
    // 添加图片
    AddPhoto() {
      if (!this.addItem.memberId) {
        return this.$message.error("请输入用户名并检测");
      }
      // if (this.addItem.sex != this.addItem.giftId.type&& this.addItem.giftId) {
      //   return this.$message.error("请选择检测性别的正确礼物");
      // }
      // let params = {
      //   aiPoint: this.addItem.aiPoint? this.addItem.aiPoint:"",
      //   giftId: this.addItem.giftId? this.addItem.giftId.id:"",
      //   isNeedGift: this.addItem.isNeedGift,
      //   isNeedReview: this.addItem.isNeedReview,
      //   isPassAudit: this.addItem.isPassAudit,
      //   isPassPorn: this.addItem.isPassPorn,
      //   type: this.addItem.type? this.addItem.type:"",
      // };
      // console.log(this.addItem);
      // this.addItem.giftId =this.addItem.giftId?this.addItem.giftId.id:""
      // console.log(this.addItem);
      this.addItem.isNeedReview = false;
      this.$api.global
        .addMemberPhoto(this.addItem)
        .then((res) => {
          this.$message.success(res)
          // this.adddialog = false
          this.$emit('handelClose')
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
    },
  },
};
</script>
<style lang="scss" scoped>
.man {
  background-color: #f4f9ff;
}
.woman {
  background-color: #fffbfb;
}
</style>
